﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";

export function initCheckout() {
    let checkoutLogin = $('[data-id="checkout-login"]');
    if (checkoutLogin.length) {
        let hasUserAccount = $('input[type="radio"][name="HasUserAccount"]');
        hasUserAccount.on("change", function () {
            let value = $("input[type='radio'][name='HasUserAccount']:checked").val();
            console.log(value);
            if (value === "true") {
                checkoutLogin.show();
            } else {
                checkoutLogin.hide();
            }
        });
        hasUserAccount.trigger("change");
    }

    let prevAddresses = $('[data-id="previous-addresses"]');
    if (prevAddresses.length) {
        prevAddresses.on("change", function () {
            let value = $(this).val();
            let addressHolder = $('[data-id="address-holder"]');
            if (value.length) {
                addressHolder.addClass('d-none');
            } else {
                addressHolder.removeClass('d-none');
            }
        });
    }
    
    let sameAsBilling = $('[data-id="same-as-billing-address"]');
    if (sameAsBilling.length) {
        sameAsBilling.on("change", function () {
            if (this.checked) {
                $('[data-id="delivery-address-holder"]').addClass('d-none');
            }
            else{
                $('[data-id="delivery-address-holder"]').removeClass('d-none');
            }
        }).trigger("change");
    }
}